import { render, staticRenderFns } from "./MainPage.vue?vue&type=template&id=e7dd77ce&"
import script from "./MainPage.vue?vue&type=script&lang=js&"
export * from "./MainPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e7dd77ce')) {
      api.createRecord('e7dd77ce', component.options)
    } else {
      api.reload('e7dd77ce', component.options)
    }
    module.hot.accept("./MainPage.vue?vue&type=template&id=e7dd77ce&", function () {
      api.rerender('e7dd77ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/views/MainPage.vue"
export default component.exports